import { MyPurchaseHistoryModel, MyPurchaseHistoryApiParams, getMyPurchaseHistoryProduct } from "@NA/Services/GetMyPurchaseHistory";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { HasOnSuccess, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { pushDataToDataLayer } from "@NA/Overrides/Common/Utilities/CustomTracking";
type HandlerType = CustomApiHandler<MyPurchaseHistoryApiParams, MyPurchaseHistoryModel>;

export const DispatchMyPurchaseHistory: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/LoadMyPurchaseHistory",
        result: props.parameter,
    });
};

export const LoadMyPurchaseHistory: HandlerType = async (props: any) => {
    props.apiResult = await getMyPurchaseHistoryProduct(props.parameter);
    props.purchasedProductLines = props.apiResult.result.products!;
};

export const MapProducts: HandlerType = (props: any) => {
    props.productInfosByLineId = {};
    props.purchasedProductLines?.forEach((o: any) => {
        props.productInfosByLineId[o.id] = {
            productId: o.id,
            qtyOrdered: o.qtyOrdered,
            unitOfMeasure: o.unitOfMeasure,
            productDetailPath: o.productUri,
        };
    });
};

export const LoadRealTimePrices: HandlerType = async (props: any) => {
    const { purchasedProductLines, productInfosByLineId } = props;

    if (!purchasedProductLines?.length) {
        return;
    }

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: purchasedProductLines!.map((o: any) => ({
                productId: o.id,
                unitOfMeasure: o.unitOfMeasure,
                qtyOrdered: o.qtyOrdered,
            })),
            onComplete: realTimePricingProps => {
                if (realTimePricingProps?.apiResult) {
                    realTimePricingProps.apiResult.realTimePricingResults?.forEach(pricing => {
                        for (const purchasedProductLineId in productInfosByLineId) {
                            const productInfo = productInfosByLineId[purchasedProductLineId]!;
                            if (
                                productInfo.productId === pricing.productId &&
                                productInfo.unitOfMeasure === pricing.unitOfMeasure
                            ) {
                                productInfo.pricing = pricing;                                                         
                            }
                        }                        
                    });
                } else if (realTimePricingProps.error) {
                    for (const purchasedProductLineId in productInfosByLineId) {
                        productInfosByLineId[purchasedProductLineId]!.failedToLoadPricing = true;
                    }
                }
                props.pricingLoaded = true; 
                props.realTimePricing = realTimePricingProps;
                SendTrackingCustom(props);                    
            },            
        }),
    );

    await waitFor(() => !!props.pricingLoaded);
};


export const DispatchCompleteLoadMyPurchaseHistory: HandlerType = props => {
    props.dispatch({
        type: "Custom/DispatchCompleteLoadMyPurchaseHistory",
        myPurchaseHistory: props.apiResult,
    });
};

export const DispatchCompleteLoadPricing: HandlerType = props => {
    props.dispatch({
        type: "Custom/MyPurchaseHistory/SetRealtimePricing",
        myPurchasedProductInfosByLineId: props,
    });
};
export const SendTrackingCustom: HandlerType = (props: any) => {  
    pushDataToDataLayer(props.apiResult.result.products, 'Recently Purchased Products', props.getState().context.session, props.realTimePricing.apiResult);
};
export const chain = [
    DispatchMyPurchaseHistory,
    LoadMyPurchaseHistory,
    MapProducts,
    LoadRealTimePrices,
    DispatchCompleteLoadMyPurchaseHistory,
    DispatchCompleteLoadPricing
    
];

const loadMyPurchaseHistory = createHandlerChainRunner(chain, "loadMyPurchaseHistory");
export default loadMyPurchaseHistory;